import "core-js/modules/es.object.to-string.js";
export default {
  name: "ContactPopin",
  data: function data() {
    return {
      dialog: false,
      contact: {},
      resolve: null,
      reject: null
    };
  },
  methods: {
    open: function open(contact) {
      var _this = this;
      this.dialog = true;
      this.contact = contact;
      return new Promise(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
      });
    },
    cancel: function cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};